import { gql } from "@apollo/client";

export const TYPE_WELL_NAMES = gql`
  query typeWells($req: ForecastQueryInput!) {
    typeWells(req: $req) {
      name
      uniqueID
      id
      wellData
    }
  }
`;
export const GET_CHANGE_RECORDS = gql`
  query changeRecords($forecastId: String!) {
    changeRecords(forecastId: $forecastId) {
      changeId
      date
      forecastId
      changedBy
      changes {
        field
        from
        to
      }
      comment
    }
  }
`;

export const GET_WELL_LIST_RECORDS = gql`
  query wellListRecords($forecastId: String!) {
    wellListRecords(forecastId: $forecastId) {
      changeId
      date
      changedBy
      date
      forecastId
      wellList
      isFavorite
      filterJSON
    }
  }
`;

export const FOLDERS = gql`
  query folders($req: FolderQueryInput!) {
    folders(req: $req) {
      folderId
      name
      owner
      forecasts {
        id
        uniqueID
        reserveCategory
        name
        color
        thickness
        arps {
          product
          segmentIndex
          startDate
          endDate
          timeCalculated
          qi
          di
          b
          n
          qf
          trendCum
          df
          maxRate
          slopeType
          isUserRatioDecline
        }
        constants {
          uniqueId
          product
          value
          unit
        }
        wellData
        order
        source
      }
      projectId
      parentId
      order
    }
  }
`;

// Lightweight version of FOLDERS query for USER_ARPS
// Excludes heavy fields: arps, constants, wellData
// Use for forecast folder lists where full data isn't needed
export const FOLDERS_LIGHT = gql`
  query folders($req: FolderQueryInput!) {
    folders(req: $req) {
      folderId
      name
      owner
      forecasts {
        id
        uniqueID
        reserveCategory
        name
        order
        source
      }
      projectId
      parentId
      order
    }
  }
`;

// Query to fetch full details for a single forecast
// Used for lazy loading forecast details in popovers
export const GET_FORECAST_DETAILS = gql`
  query forecastDetails($forecastId: String!, $folderId: String!) {
    forecastDetails(forecastId: $forecastId, folderId: $folderId) {
      id
      uniqueID
      reserveCategory
      name
      arps {
        product
        segmentIndex
        startDate
        endDate
        timeCalculated
        qi
        di
        b
        n
        qf
        trendCum
        df
        maxRate
        slopeType
        isUserRatioDecline
      }
      constants {
        uniqueId
        product
        value
        unit
      }
      wellData
      order
      source
    }
  }
`;

export const TEMPLATES = gql`
  query templates {
    templates {
      id
      type
      name
      numberOfSegments
      order
      headers {
        name
        displayName
      }
    }
  }
`;

export const UPDATE_FOLDER_NAME = gql`
  mutation ($input: FolderInput!) {
    updateFolderName(input: $input)
  }
`;

export const SET_TYPE_WELL_DATA = gql`
  mutation ($data: WellDataInput!) {
    setWellData(input: $data)
  }
`;

export const DELETE_TYPE_WELL = gql`
  mutation ($input: DeleteWellInput!) {
    deleteTypeWell(input: $input)
  }
`;

export const DELETE_FORECAST = gql`
  mutation ($input: DeleteForecastInput!) {
    deleteForecast(input: $input)
  }
`;

export const MOVE_FORECAST = gql`
  mutation ($input: MoveForecastInput!) {
    moveForecast(input: $input)
  }
`;

export const MOVE_FOLDER = gql`
  mutation ($input: MoveFolderInput!) {
    moveFolder(input: $input)
  }
`;

export const SAVE_FORECAST = gql`
  mutation ($input: SaveForecastInput!) {
    saveForecast(input: $input)
  }
`;

export const UPDATE_TYPE_WELL_STYLE = gql`
  mutation setTypeWellStyle($input: TypeWellStyleInput!) {
    setTypeWellStyle(input: $input) {
      id
      color
      thickness
    }
  }
`;

export const NEW_COMMENT = gql`
  mutation ($input: NewCommentInput!) {
    newComment(input: $input)
  }
`;

export const RESTORE_FORECAST = gql`
  mutation ($input: RestoreForecastInput!) {
    restoreForecast(input: $input) {
      product
      segmentIndex
      startDate
      endDate
      qi
      di
      b
      n
      qf
      trendCum
      df
      maxRate
      parentId
      minDecline
      timeCalculated
      diCalculated
      slopeType
      isUserRatioDecline
    }
  }
`;

export const FETCH_FORECAST_ARRAY = gql`
  query forecastArray($req: ForecastArrayInput) {
    forecastArray(req: $req)
  }
`;

/**
 * Mutation to toggle favorite status of a well list record.
 *
 * Behavior:
 * - If the specified record is already favorite: It will be unfavorited (isFavorite set to false)
 * - If the specified record is not favorite: It will be favorited and all other records
 *   for the same forecast will be unfavorited
 *
 * This ensures that only one well list record can be marked as favorite per forecast at any given time.
 *
 * @param input.forecastId - The forecast identifier
 * @param input.wellListRecordId - The ID of the well list record to toggle (changeId)
 * @returns Boolean indicating success (true) or failure (false)
 */
export const SET_FAVORITE_WELL_LIST = gql`
  mutation SetFavoriteWellList($input: SetFavoriteWellListInput!) {
    setFavoriteWellList(input: $input)
  }
`;
export const SAVE_FOLDER_WITH_TYPE_WELLS = gql`
  mutation CopyFolder($input: CopyFolderInput!) {
    copyFolder(input: $input) {
      id
      folderId
      name
    }
  }
`;
